import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { IOrderUsers, IUsers } from '../dto/OrderUsers';

@Module({ dynamic: true, store, name: 'user', namespaced: true })
class OrderUsers extends VuexModule implements IOrderUsers {
    // state
    /**
     * @state
     * データ移動状態
     */
    moveState = '0';

    /**
     * @state
     * ユーザ情報
     */
    users: IUsers = {
        szkCd: '',
        naibCd: '',
        userId: '',
    };

    /**
     * @state
     * 再検索フラグ
     * ='1'の時再検索を行う
     */
    reSearchFlag = '0';

    /**
     * @state
     * フォームデータ
     * 検索条件を格納する
     */
    formData: any = [];

    // getter
    /**
     * @Getter
     * パスの取得
     */
    get GET_PATH() {
        // return `/${this.users.szkCd}/${this.users.naibCd}/${this.users.userId}`;
        return `/${this.users.userId}`;
    }

    /**
     * @Getter
     * ユーザ設定の有無
     */
    get IS_SET_USER() {
        return this.users.userId !== '';
    }

    /**
     * @Getter
     * 移動状況の確認
     */
    get CHECK_MOVE_STATE() {
        if (this.moveState === '1') {
            return true;
        }
        return false;
    }

    /**
     * @getter
     * reSearchFlagの取得
     * 1ならtrueを返す
     */
    get CHECK_RE_SEARCH() {
        if (this.reSearchFlag === '1') {
            return true;
        }
        return false;
    }

    /**
     * @Getter
     * formDataの取得
     */
    get GET_FORM_DATA() {
        return this.formData;
    }

    // Action
    /**
     * @Action
     * 組織情報の保管
     * @param param (IOrg)組織情報
     */
    @Action({})
    public setUsers(param: IUsers) {
        this.SET_ORG(param);
    }

    /**
     * @Action
     * 登録画面移動時のフラグ変更
     */
    @Action({})
    public transferToInfo() {
        this.TRANSFER_TO_INFO();
    }

    /**
     * @Action
     * 登録画面到着時のフラグ変更
     */
    @Action({})
    public arrivalToInfo() {
        this.ARRIVAL_TO_INFO();
    }

    /**
     * @Action
     * フォームデータの保管
     * @param data
     */
    @Action({})
    public setFormData(data: any) {
        this.SET_FORM_DATA(data);
    }
    /**
     * @Action
     * ストアモジュールのリセット
     */
    @Action({})
    public moduleReset() {
        this.MODULE_RESET();
    }

    /**
     * @Action
     * ストアモジュールのリセット
     */
    @Action({})
    public moduleSelectReset() {
        this.MODULE_USR_RESET();
    }

    // Mutation
    /**
     * @Mutation
     * ユーザ情報の保管
     * @param param (Iusers)組織情報
     */
    @Mutation
    private SET_ORG(param: IUsers) {
        this.users = param;
    }

    /**
     * @Mutation
     * 一覧画面移動時のフラグ変更
     */
    @Mutation
    private TRANSFER_TO_INFO() {
        this.moveState = '1';
    }

    /**
     * @Mutation
     * 一覧画面到着時のフラグ変更
     */
    @Mutation
    private ARRIVAL_TO_INFO() {
        this.moveState = '0';
    }

    /**
     * @Mutation
     * @param data
     */
    @Mutation
    private SET_FORM_DATA(data: any) {
        this.reSearchFlag = '1';
        this.formData = data;
    }

    @Mutation
    private MODULE_RESET() {
        this.moveState = '0';
        this.users = {
            szkCd: '',
            naibCd: '',
            userId: '',
        };
        this.reSearchFlag = '0';
        this.formData = [];
    }

    @Mutation
    private MODULE_USR_RESET() {
        this.moveState = '0';
        this.users = {
            szkCd: '',
            naibCd: '',
            userId: '',
        };
    }
}

export const orderUsersModule = getModule(OrderUsers);
